export default __webpack_public_path__ + "static/media/chani worry.e2d3ce69.svg";